import { render } from "./PrintCenter.vue?vue&type=template&id=34bbcffd&scoped=true"
import script from "./PrintCenter.vue?vue&type=script&lang=js"
export * from "./PrintCenter.vue?vue&type=script&lang=js"

import "./PrintCenter.vue?vue&type=style&index=0&id=34bbcffd&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bbcffd"]])

export default __exports__